import styled from 'styled-components';
import { Input as SemanticInput } from 'semantic-ui-react';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  gap: 1px;
`;

const Input = styled(SemanticInput)`
`;

const Label = styled(TextLayoutComponent)`
  margin-left: 0.2rem;
`;

const Title = styled(TextLayoutComponent)``;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  max-height: 150px;
  padding: 0 10px;
  `;

export {
  CheckboxContainer,
  Input,
  OptionsContainer,
  Label,
  Title,
};
